import { KEY } from 'store/booking/types';
import { pastAppointmentsRequestStateSelector } from './selectors';

/**
 * NOTE: We do not currently use this action
 * but I wanted to keep it since this section of the app is evolving
 */

export const GET_PAST_APPOINTMENTS = `${KEY}.GET_PAST_APPOINTMENTS`;
export const GET_PAST_APPOINTMENTS_SUCCESS = `${KEY}.GET_PAST_APPOINTMENTS_SUCCESS`;
export const GET_PAST_APPOINTMENTS_FAIL = `${KEY}.GET_PAST_APPOINTMENTS_FAIL`;

export const getPastAppointments = (useRequestState = true) => ({
  type: GET_PAST_APPOINTMENTS,
  payload: {
    useRequestState,
    requestStateSelector: pastAppointmentsRequestStateSelector,
    client: 'booking',
    request: {
      url: '/booking/pastappointments'
    }
  }
});
